<template>
	<div id="App">
		<!-- <Layout> -->
		<router-view />
		<!-- </Layout> -->
	</div>
</template>

<script>
export default {
	name: 'App',
	components: {},
}
</script>

<style lang="scss">
// 重置浏览器样式
@import './assets/style/normalize.scss';
@import './assets/style/reset.scss';
@import './assets/style/base.scss';
// 公用css、scss变量
@import './assets/style/common.scss';
// iconfont图标库（只做引入示例，项目不需要可以去掉）
// @import '~@/assets/iconfont/iconfont.css';
#app {
	font-size: 14px;
	color: #606060;
	font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'SF UI Text', 'Helvetica Neue', STHeiti, 'Microsoft Yahei', Tahoma, Simsun, sans-serif;
}
.view_refresh_div{
  position: fixed;
  top: 0;
  right: 0;
  width: 20vh;
  height: 10vh;
  z-index: 99;
  cursor: pointer;
}
</style>
<style>
@import url("./assets/clear.scss");
</style>


// WEBPACK FOOTER //
// src/App.vue